import type { LevelData } from '../../game/level/LevelData';

function readFileFromDragEvent(e: DragEvent): Promise<unknown> {
  return new Promise<unknown>((resolve) => {
    const file = e?.dataTransfer?.files?.[0];
    if (file && file.type === 'application/json') {
      const reader = new FileReader();
      reader.onload = (): void => {
        try {
          const json: unknown = JSON.parse(reader.result as string);
          resolve(json);
        } catch (err) {
          console.error('Invalid JSON', err);
          resolve(null);
        }
      };
      reader.readAsText(file);
    } else {
      resolve(null);
      console.error('Not a JSON file');
    }
  });
}

function isLevelFile(json: unknown): json is LevelData {
  if (json === null) return false;
  if (typeof json !== 'object') return false;
  return 'goal' in json && 'reward' in json && 'board' in json;
}

export function initFileDropHandler(startLevel: (levelData: LevelData) => void): void {
  document.addEventListener('dragover', (e) => {
    e.preventDefault();
  });
  document.addEventListener('drop', async (e) => {
    e.preventDefault();

    const json = await readFileFromDragEvent(e);

    if (json === null) return;

    if (isLevelFile(json)) {
      startLevel(json);
    }
  });
}
